
import * as plotUtil from '../plot_util'

const HALF_PI = Math.PI / 2
/**** 细直箭头 */
const fine_arrow_opts = {
    tailWidthFactor: 0.15,
    neckWidthFactor: 0.2,
    headWidthFactor: 0.25,
    headAngle: Math.PI / 8.5,
    neckAngle: Math.PI / 13
}

export const arrow_algorithm = function (coordinates, opt) {
    if (coordinates.length < 2) return []
    let [pnt1, pnt2] = coordinates;
    let len = plotUtil.getBaseLength(coordinates)
    const { neckWidthFactor, tailWidthFactor, headWidthFactor, headAngle, neckAngle } = opt
    let tailWidth = len * tailWidthFactor;
    let neckWidth = len * neckWidthFactor;
    let headWidth = len * headWidthFactor;
    let tailLeft = plotUtil.getThirdPoint(pnt2, pnt1, HALF_PI, tailWidth, true);
    let tailRight = plotUtil.getThirdPoint(pnt2, pnt1, HALF_PI, tailWidth, false);
    let headLeft = plotUtil.getThirdPoint(pnt1, pnt2, headAngle, headWidth, false);
    let headRight = plotUtil.getThirdPoint(pnt1, pnt2, headAngle, headWidth, true);
    let neckLeft = plotUtil.getThirdPoint(pnt1, pnt2, neckAngle, neckWidth, false);
    let neckRight = plotUtil.getThirdPoint(pnt1, pnt2, neckAngle, neckWidth, true);
    return [[tailLeft, neckLeft, headLeft, pnt2, headRight, neckRight, tailRight]];
}

export default function (coordinates) {
    return arrow_algorithm(coordinates, fine_arrow_opts);
}